import { toastifyMessage } from '../../../handlers/toastifyMessage';

const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;

export const logOutFromFB = () => {
    // Use native JavaScript event listener
    const handleFBSDKLoaded = () => {
        if (window.FB) {
            window.FB.getLoginStatus(function (response) {
                try {
                    if (response.status === "connected") {
                        window.FB.api("/me/permissions", "delete", null);
                        window.FB.logout(function (response) {
                            // Logout successful
                        });
                    }
                } catch (error) {
                    toastifyMessage("Something went wrong...!", undefined, "error");
                }
            });
        }
    };

    // Check if FB is already loaded
    if (window.FB) {
        handleFBSDKLoaded();
    } else {
        // Wait for FB SDK to load
        document.addEventListener('FBSDKLoaded', handleFBSDKLoaded, { once: true });
    }
};